import { useAuthStore } from '@/stores/auth';
import router from '@/router';
import { watch } from 'vue';

const INACTIVITY_LIMIT_MS = 15 * 60 * 1000; // 15 minutes
const REFRESH_MARGIN_MS = 5 * 60 * 1000; // refresh 5 minutes before expiry
const CHECK_INTERVAL_MS = 60 * 1000; // check every minute

export default function setupTokenRefresh() {
  const auth = useAuthStore();
  let lastActivity = Date.now();
  let intervalId: number | null = null;
  const activityEvents = ['mousemove', 'keydown', 'click', 'scroll'];

  const updateActivity = () => {
    lastActivity = Date.now();
  };

  const startInterval = () => {
    if (intervalId !== null) return;
    intervalId = window.setInterval(async () => {
      if (!auth.expiresAt || !auth.isAuthenticated) {
        return;
      }
      const expires = new Date(auth.expiresAt).getTime();
      const now = Date.now();

      if (now >= expires) {
        auth.logout();
        router.push('/login');
        return;
      }

      if (now - lastActivity < INACTIVITY_LIMIT_MS && expires - now <= REFRESH_MARGIN_MS) {
        const ok = await auth.refreshTokens();
        if (!ok) {
          auth.logout();
          router.push('/login');
        }
      }
    }, CHECK_INTERVAL_MS);
  };

  const stopInterval = () => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  activityEvents.forEach((evt) => window.addEventListener(evt, updateActivity));

  watch(
    () => auth.isAuthenticated,
    (isAuth) => {
      if (isAuth) {
        lastActivity = Date.now();
        startInterval();
      } else {
        stopInterval();
      }
    },
    { immediate: true }
  );

  return () => {
    stopInterval();
    activityEvents.forEach((evt) =>
      window.removeEventListener(evt, updateActivity)
    );
  };
}
